import Link from "next/link";
import { useRouter } from "next/router";
import React, { useState } from "react";
import { Fade } from "react-reveal";
import Image from "next/image";
import { getAssignedkeywords, getToken } from "../utilities/utils";
import { Transition } from "react-transition-group";
import ContactUsPopup from "../components/common/ContactUsPopup";
import {
  Menubar,
  MenubarContent,
  MenubarItem,
  MenubarMenu,
  MenubarArrow,
  MenubarTrigger,
} from "@/components/ui/menubar";
import ManualUpgradePopUp from "../components/dashboard/UpgradePopup/ManualUpgradePopUp";

const DashboardSidebar = () => {
  const [isSideBar, setIsSideBar] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const router = useRouter();
  const [menuOpen, setMenuOpen] = useState(null);
  const allowedKeywords = getAssignedkeywords();
  const [contactPopupOpen, setContactPopupOpen] = useState(false);
  const [upgradePopup, setUpgradePopup] = useState(false);
  // Toggles the visibility of the UpgradePopUp
  const toggleUpgradePopup = () => setUpgradePopup(!upgradePopup);

  const handleContactUsClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setContactPopupOpen(true);
  };

  const SIDE_DATA = [
    {
      ico: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="25"
          className={`w-fit ${isSideBar ? "mx-0" : "mx-auto"} `}
          viewBox="0 0 24 24"
          fill=""
        >
          <mask
            id="mask0_513_8866"
            style={{ maskType: "alpha" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="24"
          >
            <rect width="24" height="24" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_513_8866)">
            <path
              d="M4.15383 10.75C3.89774 10.75 3.68308 10.6633 3.50985 10.4901C3.33662 10.3169 3.25 10.1022 3.25 9.84613V4.15383C3.25 3.89774 3.33662 3.68308 3.50985 3.50985C3.68308 3.33662 3.89774 3.25 4.15383 3.25H9.84613C10.1022 3.25 10.3169 3.33662 10.4901 3.50985C10.6633 3.68308 10.75 3.89774 10.75 4.15383V9.84613C10.75 10.1022 10.6633 10.3169 10.4901 10.4901C10.3169 10.6633 10.1022 10.75 9.84613 10.75H4.15383ZM14.1538 10.75C13.8977 10.75 13.6831 10.6633 13.5099 10.4901C13.3366 10.3169 13.25 10.1022 13.25 9.84613V4.15383C13.25 3.89774 13.3366 3.68308 13.5099 3.50985C13.6831 3.33662 13.8977 3.25 14.1538 3.25H19.8461C20.1022 3.25 20.3169 3.33662 20.4901 3.50985C20.6633 3.68308 20.75 3.89774 20.75 4.15383V9.84613C20.75 10.1022 20.6633 10.3169 20.4901 10.4901C20.3169 10.6633 20.1022 10.75 19.8461 10.75H14.1538ZM4.15383 20.75C3.89774 20.75 3.68308 20.6633 3.50985 20.4901C3.33662 20.3169 3.25 20.1022 3.25 19.8461V14.1538C3.25 13.8977 3.33662 13.6831 3.50985 13.5099C3.68308 13.3366 3.89774 13.25 4.15383 13.25H9.84613C10.1022 13.25 10.3169 13.3366 10.4901 13.5099C10.6633 13.6831 10.75 13.8977 10.75 14.1538V19.8461C10.75 20.1022 10.6633 20.3169 10.4901 20.4901C10.3169 20.6633 10.1022 20.75 9.84613 20.75H4.15383ZM16.9997 20.75C16.7871 20.75 16.609 20.6781 16.4654 20.5343C16.3218 20.3906 16.25 20.2125 16.25 20V17.75H13.975C13.7686 17.75 13.5961 17.6781 13.4577 17.5343C13.3192 17.3904 13.25 17.2122 13.25 16.9997C13.25 16.7871 13.3219 16.609 13.4656 16.4654C13.6094 16.3218 13.7875 16.25 14 16.25H16.25V13.975C16.25 13.7686 16.3219 13.5961 16.4657 13.4577C16.6095 13.3192 16.7877 13.25 17.0003 13.25C17.2129 13.25 17.391 13.3219 17.5346 13.4656C17.6782 13.6094 17.75 13.7875 17.75 14V16.25H20.025C20.2314 16.25 20.4038 16.3219 20.5423 16.4657C20.6807 16.6095 20.75 16.7877 20.75 17.0003C20.75 17.2129 20.6781 17.391 20.5344 17.5346C20.3906 17.6782 20.2125 17.75 20 17.75H17.75V20.025C17.75 20.2314 17.6781 20.4038 17.5343 20.5423C17.3904 20.6807 17.2122 20.75 16.9997 20.75ZM14.75 4.74995V9.25H19.25V4.74995H14.75ZM4.74995 4.74995V9.25H9.25V4.74995H4.74995ZM4.74995 14.75V19.25H9.25V14.75H4.74995Z"
              fill={router.asPath === "/dashboard" ? "#BDF864" : "#D9D9D9"}
              fillOpacity={router.asPath === "/dashboard" ? "1" : "0.6"}
            />
          </g>
        </svg>
      ),
      text: "Dashboard",
      link: "/dashboard",
    },
    {
      ico: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="25"
          className={`w-fit ${isSideBar ? "mx-0" : "mx-auto"} `}
          viewBox="0 0 24 24"
          fill="none"
        >
          <mask
            id="mask0_513_8874"
            style={{ maskType: "alpha" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="24"
          >
            <rect width="24" height="24" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_513_8874)">
            <path
              d="M21.2457 22.1028L18.4827 19.3855C18.1673 19.6124 17.8191 19.7842 17.4381 19.9009C17.0571 20.0176 16.6619 20.0759 16.2526 20.0759C15.1327 20.0759 14.1834 19.6881 13.4046 18.9124C12.6258 18.1368 12.2365 17.1913 12.2365 16.0759C12.2365 14.9606 12.6258 14.015 13.4046 13.2394C14.1834 12.4638 15.1327 12.0759 16.2526 12.0759C17.3724 12.0759 18.3218 12.4638 19.1005 13.2394C19.8793 14.015 20.2687 14.9606 20.2687 16.0759C20.2687 16.49 20.2085 16.8884 20.0881 17.2711C19.9678 17.6538 19.7905 18.0073 19.5562 18.3317L22.3038 21.049C22.4595 21.1977 22.54 21.3718 22.5451 21.5711C22.5503 21.7705 22.475 21.9477 22.3192 22.1028C22.1699 22.2516 21.9926 22.3259 21.7873 22.3259C21.582 22.3259 21.4015 22.2515 21.2457 22.1028ZM16.2526 18.5759C16.9554 18.5759 17.5494 18.3343 18.0347 17.8509C18.52 17.3676 18.7627 16.7759 18.7627 16.0759C18.7627 15.3759 18.52 14.7843 18.0347 14.3009C17.5494 13.8176 16.9554 13.5759 16.2526 13.5759C15.5497 13.5759 14.9557 13.8176 14.4704 14.3009C13.9851 14.7843 13.7425 15.3759 13.7425 16.0759C13.7425 16.7759 13.9851 17.3676 14.4704 17.8509C14.9557 18.3343 15.5497 18.5759 16.2526 18.5759ZM2.02428 17.349C1.85823 17.2374 1.75911 17.0846 1.72693 16.8903C1.69476 16.6961 1.72951 16.5112 1.8312 16.3355L5.50556 10.4682C5.67034 10.2106 5.90301 10.0708 6.20356 10.049C6.50412 10.0272 6.75867 10.1285 6.96721 10.3529L9.17801 12.924L12.4237 7.66249C12.5949 7.37788 12.8495 7.23396 13.1874 7.23074C13.5253 7.22754 13.785 7.36313 13.9665 7.63749L15.5729 10.0471C15.2846 10.0702 15.0139 10.1096 14.761 10.1653C14.5081 10.2211 14.2561 10.2964 14.0051 10.3913L13.2308 9.23934L10.0565 14.3932C9.89176 14.6509 9.65651 14.7932 9.3508 14.8201C9.04509 14.8471 8.78798 14.7432 8.57946 14.5086L6.35899 11.9278L3.11325 17.1413C3.00127 17.3272 2.83586 17.4429 2.61703 17.4884C2.39821 17.5339 2.20062 17.4874 2.02428 17.349ZM18.2934 10.4028C18.0527 10.308 17.8059 10.2301 17.553 10.1692C17.3001 10.1083 17.0378 10.0695 16.7662 10.0528L21.209 3.03554C21.321 2.85991 21.4838 2.74677 21.6975 2.69612C21.9112 2.64548 22.1062 2.6894 22.2825 2.82787C22.4486 2.9394 22.5503 3.09228 22.5876 3.28649C22.6249 3.48073 22.5928 3.66566 22.4911 3.84129L18.2934 10.4028Z"
              fill={
                router.asPath === "/dashboard/keyword-planner"
                  ? "#BDF864"
                  : "#D9D9D9"
              }
              fillOpacity={
                router.asPath === "/dashboard/keyword-planner" ? "1" : "0.6"
              }
            />
          </g>
        </svg>
      ),
      text: "Keyword Research",
      link: "/dashboard/keyword-planner",
    },
    {
      ico: (
        <svg
          className={`w-fit ${isSideBar ? "mx-0" : "mx-auto"} `}
          width="27"
          height="25"
          viewBox="0 0 22 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.742 8.66675C12.7608 8.66675 11.9625 9.465 11.9625 10.4462C11.9625 11.4277 12.7608 12.226 13.742 12.226C14.7233 12.226 15.5215 11.4275 15.5215 10.4462C15.5215 9.465 14.7233 8.66675 13.742 8.66675ZM13.742 11.226C13.5353 11.2257 13.3372 11.1435 13.191 10.9973C13.0449 10.8511 12.9627 10.6529 12.9625 10.4462C12.9628 10.2396 13.045 10.0415 13.1911 9.89535C13.3372 9.74922 13.5354 9.66701 13.742 9.66675C13.9487 9.66701 14.1468 9.74922 14.2929 9.89535C14.439 10.0415 14.5213 10.2396 14.5215 10.4462C14.5213 10.6529 14.4391 10.8511 14.293 10.9973C14.1469 11.1435 13.9487 11.2257 13.742 11.226ZM8.25802 8.66675C7.27677 8.66675 6.47852 9.465 6.47852 10.4462C6.47852 11.4277 7.27677 12.226 8.25802 12.226C9.23927 12.226 10.0375 11.4275 10.0375 10.4462C10.0375 9.465 9.23927 8.66675 8.25802 8.66675ZM8.25802 11.226C8.05132 11.2257 7.85316 11.1435 7.70703 10.9973C7.5609 10.8511 7.47871 10.6529 7.47852 10.4462C7.47878 10.2396 7.56099 10.0415 7.70712 9.89535C7.85325 9.74922 8.05136 9.66701 8.25802 9.66675C8.46467 9.66701 8.66279 9.74922 8.80891 9.89535C8.95504 10.0415 9.03725 10.2396 9.03752 10.4462C9.03732 10.6529 8.95514 10.8511 8.809 10.9973C8.66287 11.1435 8.46471 11.2257 8.25802 11.226Z"
            fill={
              router.asPath === "/dashboard/ai-analyze" ? "#BDF864" : "#D9D9D9"
            }
            fillOpacity={
              router.asPath === "/dashboard/ai-analyze" ? "1" : "0.6"
            }
          />
          <path
            d="M19.063 8.5728H18.6495V6.87155C18.6495 5.73355 17.7238 4.80755 16.5855 4.80755H11.5V3.65505C12.2725 3.4363 12.8405 2.72655 12.8405 1.88505C12.8405 0.8703 12.015 0.0447998 11 0.0447998C9.98501 0.0447998 9.15951 0.8703 9.15951 1.88505C9.15951 2.72655 9.72751 3.4363 10.5 3.65505V4.80755H5.41451C4.27626 4.80755 3.35051 5.73355 3.35051 6.87155V8.5728H2.93701C1.82851 8.5728 0.926758 9.47455 0.926758 10.5828V12.8691C0.926758 13.9773 1.82851 14.879 2.93701 14.879H3.35051V16.5803C3.35051 17.7183 4.27626 18.6443 5.41451 18.6443H16.5855C17.7235 18.6443 18.6495 17.7183 18.6495 16.5803V14.879H19.063C20.1715 14.879 21.0733 13.9773 21.0733 12.8691V10.5828C21.0733 9.47455 20.1713 8.5728 19.063 8.5728ZM10.1595 1.8853C10.1595 1.4218 10.5365 1.0448 11 1.0448C11.4635 1.0448 11.8405 1.4218 11.8405 1.88505C11.8405 2.34855 11.4633 2.7258 11 2.7258C10.5368 2.7258 10.1595 2.3488 10.1595 1.8853ZM2.93701 13.879C2.6692 13.8788 2.41243 13.7723 2.22303 13.583C2.03364 13.3936 1.92709 13.1369 1.92676 12.8691V10.583C1.92709 10.3152 2.03364 10.0585 2.22303 9.86915C2.41243 9.6798 2.6692 9.57331 2.93701 9.57305H3.35051V13.879H2.93701ZM17.6495 16.5803C17.6492 16.8624 17.5371 17.1329 17.3376 17.3324C17.1381 17.5319 16.8676 17.644 16.5855 17.6443H5.41451C5.1324 17.644 4.86192 17.5319 4.66244 17.3324C4.46296 17.1329 4.35077 16.8624 4.35051 16.5803V6.87155C4.35077 6.58944 4.46296 6.31896 4.66244 6.11948C4.86192 5.92 5.1324 5.80781 5.41451 5.80755H16.5855C16.8676 5.80781 17.1381 5.92 17.3376 6.11948C17.5371 6.31896 17.6492 6.58944 17.6495 6.87155V14.379V16.5803ZM20.0733 12.8691C20.0729 13.1369 19.9664 13.3936 19.777 13.583C19.5876 13.7723 19.3308 13.8788 19.063 13.879H18.6495V9.5728H19.063C19.3308 9.57306 19.5876 9.67955 19.777 9.8689C19.9664 10.0582 20.0729 10.315 20.0733 10.5828V12.8691Z"
            fill={
              router.asPath === "/dashboard/ai-analyze" ? "#BDF864" : "#D9D9D9"
            }
            fillOpacity={
              router.asPath === "/dashboard/ai-analyze" ? "1" : "0.6"
            }
          />
        </svg>
      ),
      text: "Ai Analyze",
      link: "/dashboard/ai-analyze",
    },
    {
      ico: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="25"
          className={`w-fit ${isSideBar ? "mx-0" : "mx-auto"} `}
          viewBox="0 0 24 24"
          fill="none"
        >
          <mask
            id="mask0_513_8856"
            style={{ maskType: "alpha" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="24"
          >
            <rect width="24" height="24" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_513_8856)">
            <path
              d="M8.99997 11.75C8.78716 11.75 8.60896 11.6782 8.46537 11.5346C8.32179 11.391 8.25 11.2128 8.25 11C8.25 10.7872 8.32179 10.609 8.46537 10.4654C8.60896 10.3218 8.78716 10.25 8.99997 10.25H15C15.2128 10.25 15.391 10.3218 15.5346 10.4654C15.6782 10.609 15.75 10.7872 15.75 11C15.75 11.2128 15.6782 11.391 15.5346 11.5346C15.391 11.6782 15.2128 11.75 15 11.75H8.99997ZM8.99997 7.74995C8.78716 7.74995 8.60896 7.67816 8.46537 7.53458C8.32179 7.39099 8.25 7.21279 8.25 6.99998C8.25 6.78716 8.32179 6.60896 8.46537 6.46538C8.60896 6.32179 8.78716 6.25 8.99997 6.25H15C15.2128 6.25 15.391 6.32179 15.5346 6.46538C15.6782 6.60896 15.75 6.78716 15.75 6.99998C15.75 7.21279 15.6782 7.39099 15.5346 7.53458C15.391 7.67816 15.2128 7.74995 15 7.74995H8.99997ZM5.99997 14.25H13.5C13.9448 14.25 14.3564 14.3462 14.7346 14.5385C15.1128 14.7308 15.4339 15.0026 15.698 15.3538L18 18.3539V4.3077C18 4.21795 17.9711 4.14423 17.9134 4.08653C17.8557 4.02883 17.782 3.99998 17.6922 3.99998H6.3077C6.21795 3.99998 6.14423 4.02883 6.08652 4.08653C6.02882 4.14423 5.99997 4.21795 5.99997 4.3077V14.25ZM6.3077 20H17.3673L14.5173 16.2711C14.3916 16.1057 14.242 15.9775 14.0683 15.8865C13.8945 15.7955 13.7051 15.75 13.5 15.75H5.99997V19.6923C5.99997 19.782 6.02882 19.8557 6.08652 19.9134C6.14423 19.9711 6.21795 20 6.3077 20ZM17.6922 21.5H6.3077C5.80257 21.5 5.375 21.325 5.025 20.975C4.675 20.625 4.5 20.1974 4.5 19.6923V4.3077C4.5 3.80257 4.675 3.375 5.025 3.025C5.375 2.675 5.80257 2.5 6.3077 2.5H17.6922C18.1976 2.5 18.625 2.675 18.975 3.025C19.325 3.375 19.5 3.80257 19.5 4.3077V19.6923C19.5 20.1974 19.325 20.625 18.975 20.975C18.625 21.325 18.1976 21.5 17.6922 21.5Z"
              fill={
                router.asPath === "/dashboard/reports" ? "#BDF864" : "#D9D9D9"
              }
              fillOpacity={router.asPath === "/dashboard/reports" ? "1" : "0.6"}
            />
          </g>
        </svg>
      ),
      text: "Custom Reports",
      title: "Upgrade to unlock feature",
      link: allowedKeywords === "50" ? "#" : "/dashboard/reports",
      className: allowedKeywords === "50" ? "disabled-menu-item" : "",
    },
    {
      ico: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="25"
          className={`w-fit ${isSideBar ? "mx-0" : "mx-auto"} `}
          viewBox="0 0 24 24"
          fill="none"
        >
          <mask
            id="mask0_513_8860"
            style={{ maskType: "alpha" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="24"
          >
            <rect width="24" height="24" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_513_8860)">
            <path
              d="M10.4807 21.5C10.2563 21.5 10.0621 21.4246 9.89797 21.274C9.73387 21.1233 9.63516 20.9358 9.60182 20.7115L9.31145 18.4538C9.0435 18.3641 8.76882 18.2384 8.4874 18.0769C8.20598 17.9153 7.95437 17.7422 7.73257 17.5576L5.64412 18.4384C5.43002 18.532 5.21752 18.5429 5.00662 18.4711C4.79572 18.3993 4.63002 18.2647 4.5095 18.0673L3.0057 15.4481C2.89158 15.2506 2.85632 15.0397 2.89992 14.8154C2.94351 14.591 3.05568 14.4102 3.23645 14.2731L5.04415 12.9058C5.02107 12.757 5.00472 12.6077 4.9951 12.4577C4.98548 12.3077 4.98067 12.1583 4.98067 12.0096C4.98067 11.8673 4.98548 11.7227 4.9951 11.5759C5.00472 11.4291 5.02107 11.2686 5.04415 11.0942L3.23645 9.72688C3.05568 9.58971 2.94191 9.40894 2.89512 9.18458C2.84832 8.96023 2.88518 8.74934 3.0057 8.5519L4.5095 5.95195C4.63002 5.75452 4.79412 5.6199 5.00182 5.5481C5.20951 5.4763 5.4204 5.4872 5.6345 5.5808L7.72295 6.45195C7.96398 6.26092 8.22136 6.08623 8.49507 5.9279C8.76881 5.76955 9.03772 5.6423 9.30182 5.54615L9.60182 3.28848C9.63516 3.06411 9.73387 2.87661 9.89797 2.72598C10.0621 2.57533 10.2563 2.5 10.4807 2.5H13.5095C13.7338 2.5 13.9296 2.57533 14.0969 2.72598C14.2643 2.87661 14.3646 3.06411 14.3979 3.28848L14.6883 5.55578C14.9883 5.66474 15.2598 5.79198 15.5027 5.9375C15.7457 6.08302 15.9909 6.2545 16.2383 6.45195L18.3652 5.5808C18.5793 5.4872 18.7902 5.4747 18.9979 5.5433C19.2056 5.61188 19.3697 5.74489 19.4902 5.94233L20.994 8.5519C21.1146 8.74934 21.1514 8.96023 21.1046 9.18458C21.0578 9.40894 20.9441 9.58971 20.7633 9.72688L18.9171 11.123C18.953 11.2846 18.9726 11.4355 18.9758 11.5759C18.979 11.7163 18.9806 11.8577 18.9806 12C18.9806 12.1359 18.9774 12.274 18.971 12.4144C18.9646 12.5548 18.9415 12.7154 18.9017 12.8962L20.7287 14.2731C20.9094 14.4102 21.0232 14.591 21.07 14.8154C21.1168 15.0397 21.08 15.2506 20.9594 15.4481L19.4556 18.0519C19.3351 18.2493 19.1668 18.3849 18.9508 18.4586C18.7348 18.5323 18.5197 18.5224 18.3056 18.4288L16.2383 17.548C15.9909 17.7455 15.7383 17.9201 15.4806 18.0721C15.2229 18.224 14.9588 18.348 14.6883 18.4442L14.3979 20.7115C14.3646 20.9358 14.2643 21.1233 14.0969 21.274C13.9296 21.4246 13.7338 21.5 13.5095 21.5H10.4807ZM10.9999 20H12.9652L13.3249 17.3211C13.8351 17.1878 14.3015 16.9984 14.7239 16.7529C15.1463 16.5074 15.5537 16.1917 15.946 15.8058L18.4306 16.85L19.4152 15.15L17.246 13.5154C17.3294 13.2564 17.3861 13.0025 17.4162 12.7538C17.4463 12.5051 17.4614 12.2538 17.4614 12C17.4614 11.7397 17.4463 11.4884 17.4162 11.2461C17.3861 11.0038 17.3294 10.7564 17.246 10.5038L19.4345 8.84998L18.4499 7.14998L15.9364 8.2096C15.6018 7.8519 15.2008 7.53588 14.7335 7.26153C14.2662 6.98716 13.7934 6.79293 13.3152 6.67883L12.9999 3.99998H11.0152L10.6845 6.6692C10.1742 6.78972 9.70307 6.97433 9.27102 7.22305C8.83897 7.47177 8.4268 7.79228 8.0345 8.1846L5.54987 7.14998L4.56525 8.84998L6.72487 10.4596C6.64154 10.6968 6.58321 10.9436 6.54987 11.2C6.51654 11.4564 6.49987 11.7263 6.49987 12.0096C6.49987 12.2699 6.51654 12.525 6.54987 12.775C6.58321 13.025 6.63833 13.2718 6.71525 13.5154L4.56525 15.15L5.54987 16.85L8.02487 15.8C8.40436 16.1897 8.81012 16.509 9.24217 16.7577C9.67422 17.0064 10.1518 17.1974 10.6749 17.3308L10.9999 20ZM12.0114 15C12.8434 15 13.5515 14.708 14.1354 14.124C14.7194 13.54 15.0114 12.832 15.0114 12C15.0114 11.1679 14.7194 10.4599 14.1354 9.87595C13.5515 9.29198 12.8434 9 12.0114 9C11.1691 9 10.4585 9.29198 9.8797 9.87595C9.30087 10.4599 9.01145 11.1679 9.01145 12C9.01145 12.832 9.30087 13.54 9.8797 14.124C10.4585 14.708 11.1691 15 12.0114 15Z"
              fill={
                router.asPath === "/dashboard/settings" ? "#BDF864" : "#D9D9D9"
              }
              fillOpacity={
                router.asPath === "/dashboard/settings" ? "1" : "0.6"
              }
            />
          </g>
        </svg>
      ),
      text: "Settings",
      link: "/dashboard/settings",
    },
    {
      ico: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="25"
          className={`w-fit ${isSideBar ? "mx-0" : "mx-auto"} `}
          viewBox="0 0 24 24"
          fill="none"
          stroke={contactPopupOpen ? "#BDF864" : "#D9D9D9"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{ opacity: contactPopupOpen ? 1 : 0.6 }}
        >
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
          <path d="M8 10h.01" />
          <path d="M12 10h.01" />
          <path d="M16 10h.01" />
        </svg>
      ),
      text: "Contact Us",
      link: "/contact-us",
    },
  ];
  return (
    <>
      {/* Mobile Menu Button */}
      <button 
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        className="lg:hidden fixed top-4 left-4 z-50 p-2 rounded-lg bg-[#049A55] shadow-lg"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={2}
          stroke="white"
          className="w-6 h-6"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d={isMobileMenuOpen 
              ? "M6 18L18 6M6 6l12 12" 
              : "M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
            }
          />
        </svg>
      </button>

      {/* Mobile Sidebar */}
      <div 
        className={`lg:hidden fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity duration-300 ${
          isMobileMenuOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'
        }`}
        onClick={() => setIsMobileMenuOpen(false)}
      >
        <div
          className={`fixed inset-y-0 left-0 w-[250px] bg-greenBg shadow-xl z-40 transform transition-transform duration-300 ${
            isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full'
          }`}
        >
          {/* Mobile Logo */}
          <div className="px-7 flex items-center justify-center h-[71px]">
            <Image
              src={"/images/PRIMARY-LOGO-V3.png"}
              width={170}
              height={71}
              alt=""
            />
          </div>

          {/* Mobile Menu Items */}
          <Menubar value={menuOpen} className="flex flex-col border-0 p-0 h-0">
            {SIDE_DATA.map((item, index) => (
              <MenubarMenu value={index} key={index}>
                <MenubarTrigger
                  className="w-full ping p-0"
                  onClick={() => {
                    setMenuOpen(index);
                    if (allowedKeywords === "50" && item.title === "Upgrade to unlock feature") {
                      toggleUpgradePopup();
                    }
                  }}
                  title={item?.title || ""}
                >
                  {item?.onClick === undefined ? (
                    <Link
                      href={item.children ? "#" : (item.text === "Contact Us" ? "#" : item.link)}
                      className="w-full cursor-pointer"
                      onClick={(e) => {
                        if (item.text === "Contact Us") {
                          e.preventDefault();
                          setContactPopupOpen(true);
                        }
                        setIsMobileMenuOpen(false);
                      }}
                    >
                      <div
                        className={`${
                          router.asPath == item.link && "bg-white bg-opacity-5"
                        } ${
                          index === SIDE_DATA.length - 1 &&
                          "!fixed py-4 !bottom-0 right-0 h-14 left-0 border-t border-[#2A2B2A]"
                        } py-4 transition-all duration-200 flex pl-7 gap-6 items-center`}
                      >
                        <div>{item.ico}</div>
                        <span className="text-[15px] font-Commissioner font-medium text-[#ffffff] truncate z-0 opacity-[.60] transition-all duration-200">
                          <p className="w-40 text-left pl-1">{item.text}</p>
                        </span>
                      </div>
                    </Link>
                  ) : (
                    <button
                      className="w-full cursor-pointer"
                      onClick={() => {
                        if (allowedKeywords === "50") {
                          toggleUpgradePopup();
                        } else {
                          item.onClick();
                        }
                      }}
                    >
                      <div
                        className={`${
                          router.asPath == item.link && "bg-white bg-opacity-5"
                        } ${
                          index === SIDE_DATA.length - 1 &&
                          "!fixed py-4 !bottom-0 right-0 h-14 left-0"
                        } py-4 transition-all duration-200 flex pl-7 gap-6 items-center`}
                      >
                        <div>{item.ico}</div>
                        <span className="text-[15px] font-Commissioner font-medium text-[#ffffff] truncate z-0 opacity-[.60] transition-all duration-200">
                          <p className="w-40 text-left pl-1">{item.text}</p>
                        </span>
                      </div>
                    </button>
                  )}
                </MenubarTrigger>
                {item.children && (
                  <MenubarContent
                    onPointerDownOutside={() => setMenuOpen(null)}
                    side="right"
                    sideOffset={-10}
                    alignOffset={-10}
                    align="start"
                    className=" bg-greenBg border-0 text-sidebarTextColor p-6 pr-2 rounded-[10px] w-[275px] "
                  >
                    <div className="scrollbar space-y-[20px] max-h-[350px] overflow-y-auto">
                      {item.children.length > 0 ? (
                        <>
                          {item.children.map((child) => (
                            <MenubarItem key={child.id}>
                              <Link
                                href={`/dashboard/projects/?id=${child?.id}`}
                                className="flex gap-2.5"
                              >
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M10.0001 18.3333C14.6025 18.3333 18.3334 14.6024 18.3334 10C18.3334 5.39763 14.6025 1.66667 10.0001 1.66667C5.39771 1.66667 1.66675 5.39763 1.66675 10C1.66675 14.6024 5.39771 18.3333 10.0001 18.3333Z"
                                    stroke="currentColor"
                                    stroke-width="1.25"
                                  />
                                  <path
                                    d="M5 3.925C5.65 4.5175 6.99 6.13583 7.14583 7.8725C7.29167 9.49667 8.3625 10.8167 10 10.8333C10.6292 10.84 11.265 10.3858 11.2633 9.75667C11.2633 9.5625 11.2308 9.36333 11.1808 9.18C11.0978 8.89899 11.1225 8.59714 11.25 8.33333C11.7583 7.28583 12.7583 7.00417 13.55 6.435C13.9008 6.1825 14.2217 5.91583 14.3625 5.70167C14.7533 5.11 15.1433 3.92583 14.9483 3.33333M18.3333 10.8333C18.0583 11.6092 17.865 13.6458 14.765 13.6783C14.765 13.6783 12.0208 13.6783 11.1975 15.23C10.5383 16.4717 10.9225 17.8158 11.1975 18.3333"
                                    stroke="currentColor"
                                    stroke-width="1.25"
                                  />
                                </svg>
                                <span className="inline-block w-[190px]	truncate">
                                  {child.domain}
                                </span>
                              </Link>
                            </MenubarItem>
                          ))}
                        </>
                      ) : (
                        <span className="inline-block w-[190px]	truncate">
                          No projects found!
                        </span>
                      )}
                    </div>

                    <MenubarArrow
                      width={20}
                      height={20}
                      className="fill-greenBg"
                    />
                  </MenubarContent>
                )}
              </MenubarMenu>
            ))}
          </Menubar>
        </div>
      </div>

      {/* Desktop Sidebar */}
      <Fade left>
        <div
          onMouseEnter={() => setIsSideBar(true)}
          onMouseLeave={() => setIsSideBar(false)}
          className={`min-h-screen hidden lg:block ${
            isSideBar ? "w-[250px]" : "w-[80px]"
          } bg-greenBg shadow-xl sticky top-0 bottom-0 transition-all duration-500`}
        >
          <Transition in={isSideBar} timeout={500}>
            <div
              className={` ${
                isSideBar ? "px-7 " : "w-fit mx-auto"
              } flex items-center justify-center   h-[71px]`}
            >
              {isSideBar ? (
                <div className="flex !justify-between items-center ">
                  <Image
                    src={"/images/PRIMARY-LOGO-V3.png"}
                    width={170}
                    height={71}
                    alt=""
                  />
                </div>
              ) : (
                <Image
                  src={"/images/SECONDARY-LOGO-V2.png"}
                  style={{
                    maxWidth: "60px",
                    marginLeft: "-10px",
                    paddingLeft: "10px",
                  }}
                  width={130}
                  height={71}
                  alt=""
                />
              )}
            </div>
          </Transition>
          <Menubar value={menuOpen} className="flex flex-col border-0 p-0 h-0">
            {SIDE_DATA.map((item, index) => {
              return (
                <MenubarMenu value={index} key={index}>
                  <MenubarTrigger
                    className="w-full ping p-0"
                    onClick={() => {
                      setMenuOpen(index);
                      // Condition to trigger the upgrade popup on a specific menu item
                      if (
                        allowedKeywords === "50" &&
                        item.title === "Upgrade to unlock feature"
                      ) {
                        toggleUpgradePopup();
                      }
                    }}
                    title={item?.title || ""}
                  >
                    {item.text !== "Contact Us" ? (
                      item?.onClick === undefined ? (
                        <Link
                          href={item.children ? "#" : item.link}
                          className="w-full cursor-pointer"
                        >
                          <div
                            className={`${
                              router.asPath == item.link &&
                              "bg-white bg-opacity-5"
                            } ${
                              index === SIDE_DATA.length - 1 &&
                              "!fixed py-4 !bottom-0 right-0 h-14 left-0 border-t border-[#2A2B2A]"
                            } py-4 transition-all duration-200 ${
                              isSideBar
                                ? "flex pl-7 gap-6 items-center"
                                : "flex pl-7 gap-6 items-center"
                            }`}
                          >
                            <div>{item.ico}</div>
                            <span
                              className={`
                              text-[15px]
                              font-Commissioner
                              font-medium
                              text-[#ffffff]
                              truncate
                              z-0
                              opacity-[.60]
                              transition-all
                              duration-200
                              ${
                                item.link === router.asPath.split("?")[0] &&
                                "!text-[#BDF864] !opacity-100"
                              }
                              ${!isSideBar && "hidden"}
                            `}
                            >
                              <p className="w-40 text-left pl-1">{item.text}</p>
                            </span>
                          </div>
                        </Link>
                      ) : (
                        <button
                          className="w-full cursor-pointer"
                          onClick={() => {
                            // If the condition is met, show the upgrade popup rather than performing the default action
                            if (allowedKeywords === "50") {
                              toggleUpgradePopup();
                            } else {
                              item.onClick();
                            }
                          }}
                        >
                          <div
                            className={`${
                              router.asPath == item.link &&
                              "bg-white bg-opacity-5"
                            } ${
                              index === SIDE_DATA.length - 1 &&
                              "!fixed py-4 !bottom-0 right-0 h-14 left-0"
                            } py-4 transition-all duration-200 ${
                              isSideBar
                                ? "flex pl-7 gap-6 items-center"
                                : "flex pl-7 gap-6 items-center"
                            }`}
                          >
                            <div>{item.ico}</div>
                            <span
                              className={`
                              text-[15px]
                              font-Commissioner
                              font-medium
                              text-[#ffffff]
                              truncate
                              z-0
                              opacity-[.60]
                              transition-all
                              duration-200
                              ${
                                item.link === router.asPath.split("?")[0] &&
                                "!text-[#BDF864] !opacity-100"
                              }
                              ${!isSideBar && "hidden"}
                            `}
                            >
                              <p className="w-40 text-left pl-1">{item.text}</p>
                            </span>
                          </div>
                        </button>
                      )
                    ) : (
                      <button
                        onClick={handleContactUsClick}
                        className="w-full cursor-pointer text-left"
                      >
                        <div
                          className={`${
                            contactPopupOpen &&
                            "bg-white bg-opacity-5"
                          } ${
                            index === SIDE_DATA.length - 1 &&
                            "!fixed py-4 !bottom-0 right-0 h-14 left-0"
                          } py-4 transition-all duration-200 ${
                            isSideBar
                              ? "flex pl-7 gap-6 items-center"
                              : "flex pl-7 gap-6 items-center"
                          }`}
                        >
                          <div>{item.ico}</div>
                          <span
                            className={`
                              text-[15px]
                              font-Commissioner
                              font-medium
                              text-[#ffffff]
                              truncate
                              z-0
                              opacity-[.60]
                              transition-all
                              duration-200
                              ${
                                contactPopupOpen &&
                                "!text-[#BDF864] !opacity-100"
                              }
                              ${!isSideBar && "hidden"}
                            `}
                          >
                            <p className="w-40 text-left pl-1">{item.text}</p>
                          </span>
                        </div>
                      </button>
                    )}
                  </MenubarTrigger>
                  {item.children && (
                    <MenubarContent
                      onPointerDownOutside={() => setMenuOpen(null)}
                      side="right"
                      sideOffset={-10}
                      alignOffset={-10}
                      align="start"
                      className=" bg-greenBg border-0 text-sidebarTextColor p-6 pr-2 rounded-[10px] w-[275px] "
                    >
                      <div className="scrollbar space-y-[20px] max-h-[350px] overflow-y-auto">
                        {item.children.length > 0 ? (
                          <>
                            {item.children.map((child) => (
                              <MenubarItem key={child.id}>
                                <Link
                                  href={`/dashboard/projects/?id=${child?.id}`}
                                  className="flex gap-2.5"
                                >
                                  <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M10.0001 18.3333C14.6025 18.3333 18.3334 14.6024 18.3334 10C18.3334 5.39763 14.6025 1.66667 10.0001 1.66667C5.39771 1.66667 1.66675 5.39763 1.66675 10C1.66675 14.6024 5.39771 18.3333 10.0001 18.3333Z"
                                      stroke="currentColor"
                                      stroke-width="1.25"
                                    />
                                    <path
                                      d="M5 3.925C5.65 4.5175 6.99 6.13583 7.14583 7.8725C7.29167 9.49667 8.3625 10.8167 10 10.8333C10.6292 10.84 11.265 10.3858 11.2633 9.75667C11.2633 9.5625 11.2308 9.36333 11.1808 9.18C11.0978 8.89899 11.1225 8.59714 11.25 8.33333C11.7583 7.28583 12.7583 7.00417 13.55 6.435C13.9008 6.1825 14.2217 5.91583 14.3625 5.70167C14.7533 5.11 15.1433 3.92583 14.9483 3.33333M18.3333 10.8333C18.0583 11.6092 17.865 13.6458 14.765 13.6783C14.765 13.6783 12.0208 13.6783 11.1975 15.23C10.5383 16.4717 10.9225 17.8158 11.1975 18.3333"
                                      stroke="currentColor"
                                      stroke-width="1.25"
                                    />
                                  </svg>
                                  <span className="inline-block w-[190px]	truncate">
                                    {child.domain}
                                  </span>
                                </Link>
                              </MenubarItem>
                            ))}
                          </>
                        ) : (
                          <span className="inline-block w-[190px]	truncate">
                            No projects found!
                          </span>
                        )}
                      </div>

                      <MenubarArrow
                        width={20}
                        height={20}
                        className="fill-greenBg"
                      />
                    </MenubarContent>
                  )}
                </MenubarMenu>
              );
            })}
          </Menubar>
        </div>
      </Fade>

      {/* Add the ContactUsPopup component outside the sidebar div */}
      <ContactUsPopup
        isOpen={contactPopupOpen}
        onClose={() => setContactPopupOpen(false)}
      />
      {/* Render the upgrade popup when upgradePopup state is true */}
      {upgradePopup && <ManualUpgradePopUp setIsPopup={setUpgradePopup} isPopup={upgradePopup} />}
    </>
  );
};

export default DashboardSidebar;
